module.exports = {
    "level_text": {
        "meta": {
            "default_lang": "en"
        },
        "type": "translatable-text",
        "value": null,
        "translations": []
    },
}